var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1235_5718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.05007 9.04995L9.24042 8.82787C9.94914 8.00103 10.3145 6.87552 10.1136 5.67592L9.05007 9.04995ZM9.05007 9.04995L8.82799 9.2403C8.00115 9.94902 6.87566 10.3144 5.67606 10.1135C4.04075 9.83669 2.72962 8.46575 2.52974 6.81966L2.52965 6.81892C2.22266 4.32171 4.32183 2.22254 6.81904 2.52953L6.81978 2.52962C8.46584 2.7295 9.83677 4.04059 10.1136 5.67586L9.05007 9.04995ZM9.83338 10.1262V9.83326H10.1256L12.8057 12.526L12.8065 12.5268C12.8846 12.6049 12.8846 12.735 12.8065 12.813C12.7284 12.8911 12.5983 12.8911 12.5203 12.813L9.83338 10.1262ZM2.83338 6.33326C2.83338 8.2694 4.39724 9.83326 6.33338 9.83326C8.26953 9.83326 9.83338 8.2694 9.83338 6.33326C9.83338 4.39712 8.26953 2.83326 6.33338 2.83326C4.39724 2.83326 2.83338 4.39712 2.83338 6.33326Z",
    fill: "#4B5565",
    stroke: "#4B5565"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1235_5718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.cfac0726cfff5be88a981b07bc200d5d.svg";
export { ForwardRef as ReactComponent };